var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30127 2.625H11.6983C11.783 2.625 11.866 2.64962 11.937 2.69587C12.008 2.74211 12.0641 2.808 12.0984 2.88551C12.1327 2.96302 12.1437 3.04882 12.1302 3.13249C12.1166 3.21615 12.079 3.29408 12.022 3.35679L8.42605 7.31235C8.35284 7.39288 8.31228 7.49781 8.31228 7.60664V10.7034C8.31228 10.7754 8.2945 10.8463 8.26051 10.9098C8.22653 10.9733 8.17739 11.0274 8.11746 11.0674L6.36746 12.234C6.30157 12.278 6.225 12.3032 6.1459 12.307C6.06681 12.3108 5.98816 12.2931 5.91834 12.2558C5.84852 12.2184 5.79016 12.1628 5.74946 12.0948C5.70877 12.0269 5.68728 11.9492 5.68728 11.87V7.60664C5.68728 7.49781 5.64671 7.39288 5.5735 7.31235L1.97755 3.35679C1.92053 3.29408 1.88296 3.21615 1.8694 3.13249C1.85585 3.04882 1.86688 2.96302 1.90117 2.88551C1.93546 2.808 1.99152 2.74211 2.06255 2.69587C2.13358 2.64962 2.21651 2.625 2.30127 2.625V2.625Z",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1dc754bd666899bce4e194600df19754.svg";
export { ForwardRef as ReactComponent };